import React, { useEffect } from 'react';
import clsx from 'clsx';
import { useLocation } from 'react-router-dom';
import apiService from '../../services/apiService';
import '../../styling/SpinnerStyle.css';
import '../../styling/Styles.css';
import QualityTabs from './QualityTabs';
import GithubRepoPopUp from './PopUps/GithubRepoPopUp';

const checkIfGithubUnsynced = () => {

    const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
    const projectDataPages = JSON.parse(localStorage.getItem('data'))[selectedProject].pages;
    let checkUnsyncedData = false;

    projectDataPages.forEach( (page) => {
        if(page.javascript !== undefined && page.javascript.changeJavascript === true){
            checkUnsyncedData = true;
        }
    })

    return checkUnsyncedData;

}

const checkIfQualityDataExists = (stateReason) => {
    const selectedProject =JSON.parse(localStorage.getItem('selectedProject'));
    const tempProjectData = JSON.parse(localStorage.getItem('data'))[selectedProject];
    let exists = false;

    if(stateReason === 'server'){
        if(tempProjectData.projectQuality.backEndQualityData.overallQualityScore > 0){
            exists = true;
        }
    }
    if(stateReason === 'front'){
        if(tempProjectData.projectQuality.frontEndQualityData.overallQualityScore > 0){
            exists = true;
        }
    }
    return exists;
}


const ProjectQuality = (props) => {

    const {
        selectedProject,
        setLoadAnalyticsSpinner,
        setLoadGithubAnalyticsSpinner,
        loadPages
    } = props;

    const [projectQualityName, setProjectQualityName] = React.useState('');
    const { state } = useLocation();
    const [metricsData, setMetricsData] = React.useState();
    const [openGithubRepo, setOpenGithubRepo] = React.useState(false);
    const [cause, setCause] = React.useState('')

    useEffect( () => {

        if (selectedProject !== -1){
            setLoadAnalyticsSpinner(true);
            const currentProjectName = JSON.parse(localStorage.getItem('data'))[selectedProject].name;
            if(state.reason === 'server'){
                setProjectQualityName(`${currentProjectName}-server`);
            }
            else if (state.reason === 'front'){
                setProjectQualityName(`${currentProjectName}-front-end`)
            }
        }
    },[state,selectedProject])

    useEffect( () => {

        if (selectedProject !== -1 && loadPages === true){

            let repoName = '';
            const { owner } = JSON.parse(localStorage.getItem('data'))[selectedProject];
            if(state.reason === 'server'){
                repoName = `${owner}-server-${JSON.parse(localStorage.getItem('data'))[selectedProject].name}`;
            }
            else if (state.reason === 'front'){
                repoName = `${owner}-frontEnd-${JSON.parse(localStorage.getItem('data'))[selectedProject].name}`;
            }

            if(checkIfQualityDataExists(state.reason) === false){
                apiService
                .analyzeProject(repoName)
                .then((data) => {
                    if(data.data.error !== undefined){
                        setOpenGithubRepo(true)
                        setCause('empty');
                    }
                    else if(checkIfGithubUnsynced() === true){
                        setMetricsData(data.data)
                        setOpenGithubRepo(true);
                        setCause('unsynced');
                    }
                    else if(data.data.message !== 'Something went wrong.'){
                        setMetricsData(data.data)
                        const projectId = JSON.parse(localStorage.getItem('data'))[selectedProject]._id;
                        const projectQuality = JSON.parse(localStorage.getItem('data'))[selectedProject].projectQuality !== undefined ? JSON.parse(localStorage.getItem('data'))[selectedProject].projectQuality : {};
                        if(state.reason === 'server'){
                            projectQuality.backEndQualityData = data.data;
                        }
                        else if (state.reason === 'front'){
                            projectQuality.frontEndQualityData = data.data;
                        }
                        apiService
                        .updateProject2(projectId, { projectQuality})
                        .then( (updatedProject) => {
                            const tempData = JSON.parse(localStorage.getItem('data'));
                            tempData[selectedProject].projectQuality = updatedProject.data.projectQuality;
                            localStorage.setItem('data',JSON.stringify(tempData));
                        })
                        .catch( err => {
                            setLoadAnalyticsSpinner(false)
                            throw err;
                        })
                    }
                    setLoadAnalyticsSpinner(false);
                })
                .catch( err => {
                    setLoadAnalyticsSpinner(false)
                    setOpenGithubRepo(true)
                    setCause('empty');
                    throw err;
                }) 
            }
            else{
                setLoadAnalyticsSpinner(false);
                if(state.reason === 'front'){
                    const { frontEndQualityData } = JSON.parse(localStorage.getItem('data'))[selectedProject].projectQuality;
                    setMetricsData(frontEndQualityData);
                }
                else if(state.reason === 'server'){
                    const { backEndQualityData } = JSON.parse(localStorage.getItem('data'))[selectedProject].projectQuality;
                    setMetricsData(backEndQualityData);
                }   

                if(checkIfGithubUnsynced() === true){
                    setOpenGithubRepo(true);
                    setCause('unsynced');
                }
            }

            
        }
    },[state, selectedProject,loadPages])

   
    return(
        
        <>
            <div className={clsx('generalMarg', 'spacingTop')}  >
                <div style ={{display: 'flex', flexDirection: 'column'}}>
                    <div style={{marginBottom: '2rem'}}>
                        <ProjectName name = {projectQualityName}/>     
                    </div>
                    <QualityTabs metricsData={metricsData}/>
                    <span style={{marginTop: '2rem'}}/>
                </div>
            </div>
            <GithubRepoPopUp
                open={openGithubRepo}
                setOpen={setOpenGithubRepo}
                setLoadGithubAnalyticsSpinner={setLoadGithubAnalyticsSpinner}
                setMetricsData={setMetricsData}
                state={state}
                cause={cause}
            />
        </>
    )

}

const ProjectName = ({name}) => 
    (
        <div style={{fontWeight: '500', fontSize: '1.5rem'}}>
            {name}
        </div>
    )
    
export default ProjectQuality;